import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';
import { PAY_METHODS, UNAVAILABLE_TEXT } from './payMethods';

// 결제수단 미리보기 — 신용/체크카드 · 계좌이체 · 법인후불 · 네이버페이 · 카카오페이를 흐리게 깔고
// 그 위에 '현재 사용 불가 · 접수는 가능합니다!' 띠를 얹는다. 선택은 되지 않는다(aria-disabled).
const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    width: '100%',
    marginTop: 28,
  },
  caption: {
    marginBottom: 10,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    color: tokens.text,
  },
  board: {
    position: 'relative',
    padding: '18px 20px',
    borderRadius: 12,
    border: `1px dashed ${tokens.line}`,
    backgroundColor: tokens.surfaceSoft,
    overflow: 'hidden',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px 10px',
    filter: 'grayscale(1) blur(0.6px)',
    opacity: 0.45,
    pointerEvents: 'none',
    userSelect: 'none',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 40,
    padding: '0 16px',
    borderRadius: 20,
    border: `1px solid ${tokens.line}`,
    backgroundColor: tokens.surface,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    color: tokens.text,
    whiteSpace: 'nowrap',
  },
  radio: {
    width: 16,
    height: 16,
    marginRight: 8,
    borderRadius: 8,
    border: `1.5px solid ${tokens.line}`,
    backgroundColor: tokens.surface,
  },
  img: {
    display: 'block',
    height: 'auto',
  },
  badge: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: 'calc(100% - 24px)',
    height: 36,
    padding: '0 16px',
    borderRadius: 18,
    border: `1px solid ${tokens.primaryLine}`,
    backgroundColor: tokens.surface,
    boxShadow: tokens.cardShadow,
    color: tokens.primaryDark,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dense: {
    marginTop: 20,
    '& $board': { padding: '14px 12px' },
    '& $chip': { height: 36, padding: '0 12px', fontSize: 13 },
    '& $badge': { height: 32, padding: '0 12px', fontSize: 13 },
  },
}));

function PayMethodPreview({ dense = false, caption = '결제수단', text = UNAVAILABLE_TEXT, methods = PAY_METHODS }) {
  const cs = useStyles();
  return (
    <div className={clsx(cs.root, dense && cs.dense)} aria-disabled="true">
      <div className={cs.caption}>{caption}</div>
      <div className={cs.board}>
        <div className={cs.list} aria-hidden="true">
          {methods.map((m) => (
            <span key={m.key} className={cs.chip}>
              <span className={cs.radio} />
              {m.image
                ? <img className={cs.img} alt={m.label} src={m.image} style={{ width: m.imageWidth }} />
                : m.label}
            </span>
          ))}
        </div>
        <span className={cs.badge} role="status">{text}</span>
      </div>
    </div>
  );
}

export default PayMethodPreview;
